/* @flow */
import React from 'react';
import Helmet from 'react-helmet';

/**
 * Renders nothing directly, but updates the DOM with the specified data. Note that
 * we don't have script tags in here, because we want these to appear at the bottom
 * of our page, and we don't want Helmet re-inserting them at the top!
 */
const AppMeta = () => (
  <Helmet
    htmlAttributes={{lang: 'en'}}
    titleTemplate="View CBD"
    defaultTitle="View CBD"
    meta={[
      {name: 'description', content: 'View CBD'},
      {property: 'og:type', content: 'article'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
    ]}
    link={[]}
  />
);

export default AppMeta;



// WEBPACK FOOTER //
// ./src/containers/AppMeta.js